import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changeShowModal } from '../../../store/actions/SideMenu';
import { PrivateRoutes } from '../../../utils/constants/routes';
import { popUp } from '../../../utils/helpersFunction';
import { Button } from '../../FormComponents/Button/Button';
import s from '../style/modalStyle.module.scss';

export const ModalDeletePromotion = ({...props}) => {
  const {otherParams} = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const onBackPromo = () => {
    dispatch(
      changeShowModal({
        nameModal: 'deletePromotion',
        stateModal: false,
        otherParams: undefined,
      }),
    );
  };

  const goPromotionPage = (otherParams: any) => {
    const {deleteFunc, values} = otherParams;

    deleteFunc({id: values.allInfo.id}).then(async () => {
      popUp({
        props: 'The action was successful',
        type: 'success',
        isCustomMessage: true,
      });
      await dispatch(
        changeShowModal({
          nameModal: 'deletePromotion',
          stateModal: false,
          otherParams: undefined,
        }),
      );
      await history.push(PrivateRoutes.promotions.list);
    });
  };

  return (
    <div className={s.modalBox}>
      <div className={s.title}>
        {' '}
        Are you sure you want to delete Promotion?{' '}
      </div>
      <div className={s.description}>
        This Promotion will be deleted Immediately. You can not undo this action{' '}
      </div>
      <div className={s.control}>
        <Button
          text="No, Cancel"
          type="submit"
          onClick={() => onBackPromo()}
          class_type="secondary"
        />
        <Button
          text="Yes, Delete Promotion"
          type="submit"
          onClick={() => goPromotionPage(otherParams)}
          class_type="main"
        />
      </div>
    </div>
  );
};
